import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface ResetPwdReq {
  /** 短信验证码 */
  code?: string
  /** 密码 */
  password?: string
  /** 确认密码 */
  confirm_pwd?:	string
}

@Injectable()
export class PasswordInitService {
  constructor (private http: Http) {}

  resetPwd (data: ResetPwdReq) {
    return this.http.post('/user/mobile/resetPwd', data)
  }
}
